<div class="d-flex align-items-center">
    <app-icon name="path" class="big-icon"></app-icon>
    <div class="o-hidden ps-1">
        <div class="name">{{ path.name }}</div>
        <div class="d-flex flex-column justify-content-center flex-md-row justify-content-md-start align-items-md-center">
            <div class="d-flex align-items-center">
                <app-icon name="clock" class="tw-w-3 tw-h-3 tw-me-1"></app-icon>
                <div class="text-xs text-light-shadow-v2 font-medium">{{ path.duration | time: { type: 'short' } }}</div>
            </div>
            <div class="mx-2 d-md-block d-none">
                <div class="vline vline-lightest-grey" [style.height.rem]="1"></div>
            </div>
            <div class="d-flex align-items-center flex-wrap">
                <app-icon name="mission-black" type="colors" class="tw-w-3 tw-h-3 tw-me-1"></app-icon>
                <div class="text-xs text-light-shadow-v2 font-medium me-1">{{ path.missions }}</div>
                <div class="text-xs text-lowercase text-light-shadow-v2">
                    {{ path.missions > 1 ? ('v3-global-missions' | translate) : ('v3-global-mission' | translate) }}
                </div>
            </div>
        </div>
    </div>
</div>
